import { waitLocale } from 'svelte-i18n';
import { i18nManager } from './i18n';

// Keep all static imports
import cleverSearchFullPage from './full-page.svelte';
import cleverSearchChatBot from './chat-bot.svelte';
import cleverSearchChat from './chat.svelte';
import cleverSearchChatInPage from './chat-in-page.svelte';
import cleverSearchChatEmbedded from './chat-embedded.svelte';
import cleverSearchToggle from './lib/components/toggler.svelte';
// export new themes
// import cleverSearchChatTheme from './themes/chat-theme.svelte';
// import cleverSearchChatBotTheme from './themes/chat-bot-theme.svelte';
// import cleverSearchToggleTheme from './lib/components/themes/toggler-theme.svelte';

// import cleverSearchResults from './lib/components/result-wrapper.svelte';
// import cleverSearchResultMain from './lib/components/result-content.svelte';
// import cleverRatingExtend from './lib/components/rating-extend.svelte';
// import cleverAnswerFilter from './lib/components/answer-filter.svelte';
// import cleverAnswerSource from './lib/components/answer-source.svelte';
// import cleverAnswerFilterIndices from './lib/components/answer-filter-indices.svelte';
// import CleverSearchSocialSharing from './lib/components/social-sharing.svelte';

// import cleverSearchInputRecognition from './lib/components/search-input-speech-recognition.svelte';
// import cleverSearchBusy from './lib/components/busy.svelte';
// import cleverRating from './lib/components/rating.svelte';
// import cleverAnswerAlternative from './lib/components/alternative-answer.svelte';
// import cleverSearchSuggestion from './lib/components/search-input-suggestion.svelte';
// import cleverSearchFaq from './lib/components/faq.svelte';
// import CleverSearchQuestionRelatedSearchSuggestions from './lib/components/question-related-search.svelte';
// import CleverSearchSourceRelatedSearchSuggestions from './lib/components/source-related-search-suggestions.svelte';
// import CleverSearchChatWrapper from './lib/components/chat-wrapper.svelte';
// import CleverSearchChatResultItem from './lib/components/chat-result-item.svelte';

import { SearchController } from './lib/controllers/search-controller';

import {
  ApplicationInsights,
  type ITelemetryItem,
} from '@microsoft/applicationinsights-web';
import { variables } from './variables';
import { defaultLogger } from './lib/telemetry/logger';

async function initializeI18n() {
  // Initialize the i18n system
  i18nManager.init();
  // Wait for locale data to be loaded
  await waitLocale();
}

// Wrap the initialization in an async IIFE instead of using top-level await
(async () => {
  try {
    await initializeI18n();

    // Keep operational traces and API diagnostics only. UI usage events and
    // page views must not be collected by this diagnostics-only instance.
    const filteringFunction = (envelope: ITelemetryItem) =>
      envelope.baseType === 'MessageData' ||
      envelope.baseType === 'RemoteDependencyData';

    const appInsights = new ApplicationInsights({
      config: {
        connectionString: variables.APP_INSIGHTS_CONNECTION_STRING,
        // Configure before SDK startup so it never reads or writes browser
        // cookies or persists telemetry/session state in browser storage.
        cookieCfg: { enabled: false },
        isStorageUseDisabled: true,
        enableSessionStorageBuffer: false,
        enableAutoRouteTracking: false,
        autoTrackPageVisitTime: false,
        disableExceptionTracking: true,
        disableAjaxTracking: true,
        disableFetchTracking: true,
        disablePageUnloadEvents: ['unload'],
        loggingLevelTelemetry: 0,
      },
    });

    appInsights.addTelemetryInitializer(filteringFunction);
    appInsights.loadAppInsights();
    defaultLogger.setAppInsights(appInsights);

    new SearchController();
  } catch (error) {
    console.error('Failed to initialize application:', error);
  }
})();
